//--------------------------------------------------------------------------------------------------
//# Imports

import { useEffect, useCallback, useState } from "react";
import { usePrivy, useWallets } from "@privy-io/react-auth";









//--------------------------------------------------------------------------------------------------
//# Variables

let API_URL;
if (window.location.hostname === "localhost") {
  API_URL = 'http://localhost:3001';
} else {
  API_URL = 'https://alchm-backend.onrender.com';
};
const API_endpoints = {'account_access': '/api/me'};











//--------------------------------------------------------------------------------------------------
//# Functions

export function useAccountOperator() {
  const { ready, authenticated, login, logout, getAccessToken, user } = usePrivy();
  const { wallets, ready: walletsReady, createWallet } = useWallets();
  const [backendUser, setBackendUser] = useState(null);
  const [backendLoading, setBackendLoading] = useState(false);
  const [backendError, setBackendError] = useState(null);

  const syncWithBackend = useCallback(async () => {
    if (!authenticated) return;

    try {
      const token = await getAccessToken();
      // console.log("Privy access token", token);

      const res = await fetch(
        API_URL + API_endpoints['account_access'],
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await res.json();
      // console.log("Backend /api/me:", data);

      setBackendUser(data.user);
    } catch (err) {
      console.error("Error calling backend:", err);
      setBackendError(err);
    } finally {
      setBackendLoading(false);
    }
  }, [authenticated, getAccessToken]);

  // Ensure wallets exist, then sync with backend
  useEffect(() => {
    if (!ready || !authenticated || !walletsReady) return;

    const ensureWalletsAndSync = async () => {
      // 1. No wallets yet -> create them
      if (!wallets || wallets.length === 0) {
        try {
          console.log("No wallets yet → creating wallets via Privy");
          await createWallet();
        } catch (err) {
          console.error("Error creating wallets:", err);
        }
        return;
      };

      // 2. Wallets exist -> sync with backend
      console.log("Wallets detected → syncing with backend");
      await syncWithBackend();
    };

    ensureWalletsAndSync();
  }, [ ready, authenticated, walletsReady, wallets, createWallet, syncWithBackend ]);

  return {
    ready,
    authenticated,
    login,
    logout,
    user,
    wallets,
    backendUser,
    backendLoading,
    backendError,
    syncWithBackend,
  };
};